import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  changePrincipalLanguage,
  geti18nextLanguage,
  getLanguageSelectlanguage,
  seti18nextLanguage,
  translationHookOptions,
} from "../../app/localization/localization";
import { ILanguage } from "../../app/models/company";
import Loader from "../common/Loader";
import LanguageDropdown from "../dropdowns/LanguageDropdown";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  UISupportedLanguages: ILanguage[];
}

const LanguageSettingsComponent: React.FC<IParams> = ({
  UISupportedLanguages,
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const [t] = useTranslation(["features"], translationHookOptions);
  const rootStore = useContext(RootStoreContext);
  const { updateuserlanguage } = rootStore.userStore;
  // Aggiungi lingua fittizia "nessuna lingua selezionata"
  const languagesWithNone: ILanguage[] = [
    { id: 0, flagIcon: "", locale: "----", name: "---" },
    ...UISupportedLanguages,
  ]
  // useEffect(() => {
  //   const uiLanguages = [
  //     { id: 0, flagIcon: "", locale: "noLanguage", name: "---" },
  //     ...UISupportedLanguages
  //   ];
  // }, []);

  // const getSelectedLanguageId = () => {
  //   const selectedLanguage = UISupportedLanguages.filter(
  //     (x) => x.locale === geti18nextLanguage()
  //   )[0];
  //   return selectedLanguage.id;
  // };

  // const setSelectedLanguage = async (languageId: number | undefined) => {
    
  //   if (languageId) {
  //     console.log("setSelectedLanguage", languageId); 
  //     setShowLoader(true);
  //     const newLanguage = UISupportedLanguages.filter(
  //       (x) => x.id === languageId
  //     )[0];
      
  //     await  updateuserlanguage(newLanguage.id);
  //     await seti18nextLanguage(newLanguage.locale);
  //     window.location.reload();
     
  //     setShowLoader(false);
  //   }
  // };

  const getSelectedLanguageId = () => {
  const  language=  getLanguageSelectlanguage();
  console.log("getSelectedLanguageId", language); // Debugging line
  if(language === "") return 0;
  const selectedLanguage = UISupportedLanguages.filter(
      (x) => x.locale === language
    )[0];
    return selectedLanguage.id;
  };



  const setSelectedLanguage = async (languageId: number | undefined) => {
    
    
     
      setShowLoader(true);
      const newLanguage = UISupportedLanguages.filter(
        (x) => x.id === languageId
      )[0];
      
      await  updateuserlanguage(newLanguage? newLanguage.id : 0);
      await changePrincipalLanguage(newLanguage ? newLanguage.id : 0);
      window.location.reload();
     
      setShowLoader(false);
    
  };
  if (showLoader) return <Loader />;

  return (
    <div style={{height:"7rem"}}>
      <span className="mr-3">{t("ui_language_label")}</span>
      <LanguageDropdown
        languages={languagesWithNone}
        selectedLanguage={getSelectedLanguageId()}
        onLanguageSelect={setSelectedLanguage}
        flagFontSize={25}
      />
    </div>
  );
};

export default LanguageSettingsComponent;
